import { callNative, requestTypes } from '../../lib/bridge';
import { Locale } from '../../types/common';

class AuthBettingPlugin {
  static isAvailable = async () => {
    try {
      const result = await callNative(requestTypes.AUTH_IS_AVAILABLE);

      return result?.data ?? false;
    } catch (e) {
      console.log('AuthBetting plugin not available');
    }

    return false;
  };

  static login = async (lang: Locale) => {
    try {
      const result = await callNative(
        requestTypes.AUTH_LOGIN,
        JSON.stringify({
          application: 'mobile-betting',
          trust_level: '3',
          lang,
        }),
      );

      return JSON.parse(result?.data);
    } catch (e) {
      if (e instanceof Error) {
        console.log('error: while calling AuthBetting.login()', e?.message);
      }
    }

    return null;
  };

  static loginAuto = async (lang: Locale) => {
    try {
      const result = await callNative(
        requestTypes.AUTH_LOGIN_AUTO,
        JSON.stringify({
          application: 'mobile-betting',
          trust_level: '3',
          lang,
        }),
      );

      return JSON.parse(result?.data);
    } catch (e) {
      if (e instanceof Error) {
        console.log('error: while calling AuthBetting.loginAuto()', e?.message);
      }
    }

    return null;
  };

  static logout = async () => {
    try {
      await callNative(requestTypes.AUTH_LOGOUT);
    } catch (e) {
      if (e instanceof Error) {
        console.log('error: while calling AuthBetting.logout()', e?.message);
      }
    }
  };

  static getToken = async () => {
    try {
      const result = await callNative(requestTypes.AUTH_GET_TOKEN);

      return JSON.parse(result?.data);
    } catch (e) {
      if (e instanceof Error) {
        console.log('error: while calling AuthBetting.getToken()', e?.message);
      }
    }
    return null;
  };
}

export default AuthBettingPlugin;
